import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  previous: { id: 'blob_session_previous_media', defaultMessage: 'Previous speaker' },
  next: { id: 'blob_session_next_media', defaultMessage: 'Next speaker' },
  position: { id: 'blob_session_progress', defaultMessage: '{current} of {total}' },
});

type MediaPagerProps = {
  index: number;
  count: number;
  onChange: (index: number) => void;
};

/** Flips through a learnable's native speaker videos and audio clips. */
export const MediaPager: FC<MediaPagerProps> = ({ index, count, onChange }) => {
  const intl = useIntl();
  const flipTo = (nextIndex: number) => onChange((nextIndex + count) % count);

  return (
    <S.Pager data-testid="blob-media-pager">
      <S.PagerButton
        type="button"
        onClick={() => flipTo(index - 1)}
        aria-label={intl.formatMessage(msgs.previous)}
        data-testid="blob-media-previous"
      >
        <Icon name="chevronLeft" />
      </S.PagerButton>
      <S.Position aria-live="polite" data-testid="blob-media-position">
        {intl.formatMessage(msgs.position, { current: index + 1, total: count })}
      </S.Position>
      <S.PagerButton
        type="button"
        onClick={() => flipTo(index + 1)}
        aria-label={intl.formatMessage(msgs.next)}
        data-testid="blob-media-next"
      >
        <Icon name="chevronRight" />
      </S.PagerButton>
    </S.Pager>
  );
};
